<template>
    <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="2">
            <circle cx="48" cy="48" r="39" />
            <path d="M63.497 51.307 48.001 66.774 32.384 51.307M48.036 27v39" />
        </g>
    </svg>
</template>
